import React, { useEffect, useState } from 'react';
import {
  addDays,
  addMonths,
  format,
  isSameDay,
  isSameMonth,
  parseISO,
} from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { Container, VendasDeProdutosContainer, Frame } from './styles';
import NavBar from '../../components/NavBar';
import Header from '../../components/Header';

import { useToast } from '../../hooks/toast';

import api from '../../services/api';

interface IVendasDeProdutos {
  data: string;
  cd: string;
  nm: string;
  val_venda: number;
  qtd: number;
  unid: string;
  descontos: number;
  total: number;
  media: number;
}

interface IDados {
  data: string;
  valor: string;
}

interface ITabelaMeses {
  mes: string;
  anoAtual: string;
  anoPassado: string;
}

const VendasDeProdutos: React.FC = () => {
  const [vendasDeProdutosData, setVendasDeProdutosData] = useState<IDados[]>(
    [] as IDados[],
  );

  const [tabelaMeses, setTabelaMeses] = useState<ITabelaMeses[]>(
    [] as ITabelaMeses[],
  );

  const [ano, setAno] = useState<number>();
  const [anoPassad, setAnoPassad] = useState<number>();

  const { addToast } = useToast();

  useEffect(() => {
    const date = new Date();
    const dt_inicial = new Date(date.getFullYear() - 1, 0, 1);
    const dt_final = new Date(date.getFullYear(), 11, 31);

    setAno(date.getFullYear());
    setAnoPassad(date.getFullYear() - 1);
    api
      .get<IVendasDeProdutos[]>('reports/vendas-de-produtos', {
        params: {
          dt_inicial: dt_inicial.toISOString().slice(0, 10),
          dt_final: dt_final.toISOString().slice(0, 10),
        },
      })
      .then((response) => {
        // Valores
        let hoje = 0;
        let ontem = 0;
        let semanaPassada = 0;
        let mes1 = 0;
        let mes2 = 0;
        let mes3 = 0;
        let mes4 = 0;
        let anoAtual = 0;
        let anoPassado = 0;

        let mes1Atual = 0;
        let mes2Atual = 0;
        let mes3Atual = 0;
        let mes4Atual = 0;
        let mes5Atual = 0;
        let mes6Atual = 0;
        let mes7Atual = 0;
        let mes8Atual = 0;
        let mes9Atual = 0;
        let mes10Atual = 0;
        let mes11Atual = 0;
        let mes12Atual = 0;

        let mes1Passado = 0;
        let mes2Passado = 0;
        let mes3Passado = 0;
        let mes4Passado = 0;
        let mes5Passado = 0;
        let mes6Passado = 0;
        let mes7Passado = 0;
        let mes8Passado = 0;
        let mes9Passado = 0;
        let mes10Passado = 0;
        let mes11Passado = 0;
        let mes12Passado = 0;

        // Datas
        const dataOntem = addDays(parseISO(date.toISOString()), -1);
        const dataSemanaPassada = addDays(parseISO(date.toISOString()), -8);
        const dataMes1 = date; // Mes atual
        const dataMes2 = addMonths(parseISO(date.toISOString()), -1); // Mes atual - 1
        const dataMes3 = addMonths(parseISO(date.toISOString()), -2); // Mes atual - 2
        const dataMes4 = addMonths(parseISO(date.toISOString()), -3); // Mes atual - 3

        response.data.forEach((linha) => {
          const dataLinha = new Date(linha.data);
          if (dataLinha.getFullYear() === date.getFullYear() - 1) {
            // Ano passado
            anoPassado += linha.total;

            if (dataLinha.getMonth() === 0) mes1Passado += linha.total;
            else if (dataLinha.getMonth() === 1) mes2Passado += linha.total;
            else if (dataLinha.getMonth() === 2) mes3Passado += linha.total;
            else if (dataLinha.getMonth() === 3) mes4Passado += linha.total;
            else if (dataLinha.getMonth() === 4) mes5Passado += linha.total;
            else if (dataLinha.getMonth() === 5) mes6Passado += linha.total;
            else if (dataLinha.getMonth() === 6) mes7Passado += linha.total;
            else if (dataLinha.getMonth() === 7) mes8Passado += linha.total;
            else if (dataLinha.getMonth() === 8) mes9Passado += linha.total;
            else if (dataLinha.getMonth() === 9) mes10Passado += linha.total;
            else if (dataLinha.getMonth() === 10) mes11Passado += linha.total;
            else if (dataLinha.getMonth() === 11) mes12Passado += linha.total;
          } else {
            // Ano atual
            anoAtual += linha.total;

            // Hoje
            if (dataLinha === date) hoje = linha.total;

            if (dataLinha.getMonth() === 0) mes1Atual += linha.total;
            else if (dataLinha.getMonth() === 1) mes2Atual += linha.total;
            else if (dataLinha.getMonth() === 2) mes3Atual += linha.total;
            else if (dataLinha.getMonth() === 3) mes4Atual += linha.total;
            else if (dataLinha.getMonth() === 4) mes5Atual += linha.total;
            else if (dataLinha.getMonth() === 5) mes6Atual += linha.total;
            else if (dataLinha.getMonth() === 6) mes7Atual += linha.total;
            else if (dataLinha.getMonth() === 7) mes8Atual += linha.total;
            else if (dataLinha.getMonth() === 8) mes9Atual += linha.total;
            else if (dataLinha.getMonth() === 9) mes10Atual += linha.total;
            else if (dataLinha.getMonth() === 10) mes11Atual += linha.total;
            else if (dataLinha.getMonth() === 11) mes12Atual += linha.total;
          }

          // Ontem
          if (isSameDay(dataLinha, dataOntem)) ontem = linha.total;

          // Semana passada
          if (isSameDay(dataLinha, dataSemanaPassada))
            semanaPassada = linha.total;

          // Mes atual
          if (isSameMonth(dataLinha, dataMes1)) mes1 += linha.total;

          // Mes atual - 1
          if (isSameMonth(dataLinha, dataMes2)) mes2 += linha.total;

          // Mes atual - 2
          if (isSameMonth(dataLinha, dataMes3)) mes3 += linha.total;

          // Mes atual - 3
          if (isSameMonth(dataLinha, dataMes4)) mes4 += linha.total;
        });

        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });

        setTabelaMeses([
          {
            mes: 'JANEIRO',
            anoAtual: formatter.format(mes1Atual),
            anoPassado: formatter.format(mes1Passado),
          },
          {
            mes: 'FEVEREIRO',
            anoAtual: formatter.format(mes2Atual),
            anoPassado: formatter.format(mes2Passado),
          },
          {
            mes: 'MARÇO',
            anoAtual: formatter.format(mes3Atual),
            anoPassado: formatter.format(mes3Passado),
          },
          {
            mes: 'ABRIL',
            anoAtual: formatter.format(mes4Atual),
            anoPassado: formatter.format(mes4Passado),
          },
          {
            mes: 'MAIO',
            anoAtual: formatter.format(mes5Atual),
            anoPassado: formatter.format(mes5Passado),
          },
          {
            mes: 'JUNHO',
            anoAtual: formatter.format(mes6Atual),
            anoPassado: formatter.format(mes6Passado),
          },
          {
            mes: 'JULHO',
            anoAtual: formatter.format(mes7Atual),
            anoPassado: formatter.format(mes7Passado),
          },
          {
            mes: 'AGOSTO',
            anoAtual: formatter.format(mes8Atual),
            anoPassado: formatter.format(mes8Passado),
          },
          {
            mes: 'SETEMBRO',
            anoAtual: formatter.format(mes9Atual),
            anoPassado: formatter.format(mes9Passado),
          },
          {
            mes: 'OUTUBRO',
            anoAtual: formatter.format(mes10Atual),
            anoPassado: formatter.format(mes10Passado),
          },
          {
            mes: 'NOVEMBRO',
            anoAtual: formatter.format(mes11Atual),
            anoPassado: formatter.format(mes11Passado),
          },
          {
            mes: 'DEZEMBRO',
            anoAtual: formatter.format(mes12Atual),
            anoPassado: formatter.format(mes12Passado),
          },
        ]);

        setVendasDeProdutosData([
          {
            data: format(date, 'dd/MM/yyyy'),
            valor: formatter.format(hoje),
          },
          {
            data: format(dataOntem, 'dd/MM/yyyy'),
            valor: formatter.format(ontem),
          },
          {
            data: format(dataSemanaPassada, 'dd/MM/yyyy'),
            valor: formatter.format(semanaPassada),
          },
          {
            data: format(dataMes1, "MMMM'/'yyyy", {
              locale: ptBR,
            }).toUpperCase(),
            valor: formatter.format(mes1),
          },
          {
            data: format(dataMes2, "MMMM'/'yyyy", {
              locale: ptBR,
            }).toUpperCase(),
            valor: formatter.format(mes2),
          },
          {
            data: format(dataMes3, "MMMM'/'yyyy", {
              locale: ptBR,
            }).toUpperCase(),
            valor: formatter.format(mes3),
          },
          {
            data: format(dataMes4, "MMMM'/'yyyy", {
              locale: ptBR,
            }).toUpperCase(),
            valor: formatter.format(mes4),
          },
          {
            data: date.getFullYear().toString(),
            valor: formatter.format(anoAtual),
          },
          {
            data: (date.getFullYear() - 1).toString(),
            valor: formatter.format(anoPassado),
          },
        ]);
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: `Não foi possível carregar VENDAS DE PRODUTOS: ${error}`,
        });
      });
  }, [addToast]);

  return (
    <Container>
      <NavBar />
      <div id="page-wrap">
        <Header />

        <VendasDeProdutosContainer>
          <h1>VENDAS DE PRODUTOS</h1>

          <Frame>
            <strong>Hoje</strong>
            <div>
              <span>
                {vendasDeProdutosData[0] ? vendasDeProdutosData[0].data : '-'}
              </span>
              <span>
                {vendasDeProdutosData[0] ? vendasDeProdutosData[0].valor : '-'}
              </span>
            </div>
          </Frame>

          <Frame>
            <strong>Ontem</strong>
            <div>
              <span>
                {vendasDeProdutosData[1] ? vendasDeProdutosData[1].data : '-'}
              </span>
              <span>
                {vendasDeProdutosData[1] ? vendasDeProdutosData[1].valor : '-'}
              </span>
            </div>

            <div>
              <span>
                {vendasDeProdutosData[2] ? vendasDeProdutosData[2].data : '-'}
              </span>
              <span>
                {vendasDeProdutosData[2] ? vendasDeProdutosData[2].valor : '-'}
              </span>
            </div>
          </Frame>

          <Frame>
            <strong>Mês</strong>
            <div>
              <span>
                {vendasDeProdutosData[3] ? vendasDeProdutosData[3].data : '-'}
              </span>
              <span>
                {vendasDeProdutosData[3] ? vendasDeProdutosData[3].valor : '-'}
              </span>
            </div>

            <div>
              <span>
                {vendasDeProdutosData[4] ? vendasDeProdutosData[4].data : '-'}
              </span>
              <span>
                {vendasDeProdutosData[4] ? vendasDeProdutosData[4].valor : '-'}
              </span>
            </div>

            <div>
              <span>
                {vendasDeProdutosData[5] ? vendasDeProdutosData[5].data : '-'}
              </span>
              <span>
                {vendasDeProdutosData[5] ? vendasDeProdutosData[5].valor : '-'}
              </span>
            </div>

            <div>
              <span>
                {vendasDeProdutosData[6] ? vendasDeProdutosData[6].data : '-'}
              </span>
              <span>
                {vendasDeProdutosData[6] ? vendasDeProdutosData[6].valor : '-'}
              </span>
            </div>
          </Frame>

          <Frame>
            <strong>Ano</strong>
            <div>
              <span>
                {vendasDeProdutosData[7] ? vendasDeProdutosData[7].data : '-'}
              </span>
              <span>
                {vendasDeProdutosData[7] ? vendasDeProdutosData[7].valor : '-'}
              </span>
            </div>

            <div>
              <span>
                {vendasDeProdutosData[8] ? vendasDeProdutosData[8].data : '-'}
              </span>
              <span>
                {vendasDeProdutosData[8] ? vendasDeProdutosData[8].valor : '-'}
              </span>
            </div>
          </Frame>

          <Frame>
            <strong>TODOS OS MESES</strong>

            <div>
              <span className="mes-tabela" />
              <span>{ano}</span>
              <span>{anoPassad}</span>
            </div>

            {tabelaMeses.map((linha) => (
              <div>
                <span className="mes-tabela">
                  {linha.mes ? linha.mes : '-'}
                </span>
                <span>{linha.anoAtual ? linha.anoAtual : '-'}</span>
                <span>{linha.anoPassado ? linha.anoPassado : '-'}</span>
              </div>
            ))}
          </Frame>
        </VendasDeProdutosContainer>
      </div>
    </Container>
  );
};

export default VendasDeProdutos;
